'use strict';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import cn from 'classnames/bind';
import Select from 'react-select';
import Creatable from 'react-select/creatable';

import { appSelectors, appOperations } from '@/state/domains/app';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';
import { DEFAULT_OPTS } from '@/state/domains/attempts/utils';

//import s from './styles.scss';
import m from '../styles.scss';
import s from './styles.scss';

const sx = cn.bind(s);

const HOURS = [ ...Array(24).keys() ].map(n => {
	const v = n.toString().padStart(2, '0')
	return { label: v, value: v };
});

const MINUTES = [ ...Array(60).keys() ].map(n => {
	const v = n.toString().padStart(2, '0')
	return { label: v, value: v };
});

export default connect(
	(state, props) => ({
		modals: appSelectors.getModalStates(state, props),
		modalProps: appSelectors.getModalProps(state, props),
		date: appSelectors.getPageDate(state, props),
		username: appSelectors.getPageUsername(state, props),
	}),
	{
		setModalClose: appOperations.setModalClose,
		postEditAttempt: attemptsOperations.postEditAttempt,
	}
)(
	({
		modals,
		modalProps,
		date,
		username,
		selectedIndices,
		postEditAttempt,
		setModalClose
	}) => {

		const { attempt } = modalProps;

		if (!attempt) {
			return <div />;
		}

		const attemptDate = new Date(attempt.date);

		const attemptHour = attemptDate.getHours();
		const attemptMinute = attemptDate.getMinutes();

		const [ hour, setHour ] = useState({
			label: attemptHour.toString().padStart(2, '0'),
			value: attemptHour,
		});

		const [ minute, setMinute ] = useState({
			label: attemptMinute.toString().padStart(2, '0'),
			value: attemptMinute,
		});

		const [ detailsState, setDetailsState ] = useState(
			(attempt.details || []).map(o => ({ label: o, value: o })),
		);

		const editAttempt = () => {

			const aDate = new Date(attemptDate);

			aDate.setHours(hour.value, minute.value)

			const data = {
				details: detailsState.map(o => o.value),
				timeDiff: aDate.getTime() - attemptDate.getTime(),
			};

			postEditAttempt(username, attempt._id, data);

			setModalClose('editAttempt');
		};

		const onHourChange = value => {
			setHour(value);
		};

		const onMinuteChange = value => {
			setMinute(value);
		};

		const handleSelectChange = values => {
			setDetailsState(values);
		};

		const onCancel = () => {

			setDetailsState(
				(attempt.details || []).map(o => ({ label: o, value: o })),
			);

			setModalClose('editAttempt');
		};

		const customStyles = {
			container: () => ({
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
			}),
			menu: () => ({
				marginTop: '8px',
				marginBottom: '8px',
				textAlign: 'center',
			}),
		};

		return (
			<Modal
				appElement={ document.getElementById('root') }
				overlayClassName={ m.modalOverlay }
				isOpen={ modals.editAttempt }
				contentLabel='Confirm Edit'
				shouldCloseOnOverlayClick={ true }
				shouldCloseOnEsc={ true }
				onRequestClose={ () => setModalClose('editAttempt') }
				className={ m.modal }
			>
				<div className={ s.cont }>
					<p className={ s.header }>Edit Attempt</p>
					<div className={ s.contents }>
						<div className={ sx('row') }>
							<label className={ s.rowLabel }>Time</label>
							<div className={ s.time }>
								<div className={ s.hour }>
									<label>Hour</label>
									<div>
										<Select
											onChange={ onHourChange }
											options={ HOURS }
											value={ hour }
											isClearable={ false }
											maxMenuHeight={ 148 }
										/>
									</div>
								</div>
								<div className={ s.minute }>
									<label>Minute</label>
									<div>
										<Select
											onChange={ onMinuteChange }
											options={ MINUTES }
											value={ minute }
											isClearable={ false }
											maxMenuHeight={ 148 }
										/>
									</div>
								</div>
							</div>
						</div>
						<div className={ s.row }>
							<label className={ s.rowLabel }>Details</label>
							<Creatable
								isMulti
								placeholder='Attempt details'
								onChange={ handleSelectChange }
								options={ DEFAULT_OPTS.map(o => ({ label: o, value: o })) }
								value={ detailsState }
								closeOnSelect={ false }
								maxMenuHeight={ 148 }
								menuIsOpen={ true }
								styles={ customStyles }
							/>
						</div>
					</div>
					<div className={ m.btns }>
						<button
							onClick={ onCancel }
							className={ m.cancel }
						>
							Cancel
						</button>
						<button
							onClick={ editAttempt }
							className={ m.proceed }
						>
							Ok
						</button>
					</div>
				</div>
			</Modal>
		);
	}
);
